module.exports = __webpack_public_path__ + "img/試験合格後機能01,02.f0e477bd.png";